import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * L204 module permission hook
 * PgCode = "pwl204f1" (ISO文件內頁建檔)
 */
export function useL204Permissions() {
  return useModulePermission(Modules.L204);
}
